import React from "react";
import { Box, Typography } from "@mui/material";

/**
 * Hudu — Base URL + API key setup. Shared: Add Integration modal + onboarding HuduSetupForm.
 * Grep: Hudu setup guide, API Documentation, API Keys, Base URL, Full access
 */
export const HuduSetupGuideSteps: React.FC<{
  /** When false, parent renders its own heading (e.g. modal title row). */
  showSetupGuideTitle?: boolean;
}> = ({ showSetupGuideTitle = true }) => (
  <>
    {showSetupGuideTitle ? (
      <Typography
        sx={{ fontFamily: "var(--theo-font-sans)", fontWeight: 600, fontSize: 15, color: "#1a1a1a", mb: 1.5 }}
      >
        Setup Guide
      </Typography>
    ) : null}
    <Typography sx={{ fontFamily: "var(--theo-font-sans)", fontSize: 14, color: "#1a1a1a", mb: 2 }}>
      Login to Hudu using <strong>admin account</strong>
    </Typography>

    <Typography sx={{ fontFamily: "var(--theo-font-sans)", fontWeight: 600, fontSize: 14, color: "#1a1a1a", mb: 1 }}>
      1. Get the Base URL
    </Typography>
    <Box component="ul" sx={{ m: 0, pl: 2.5, mb: 2, "& li": { mb: 0.75 } }}>
      <Typography component="li" sx={{ fontFamily: "var(--theo-font-sans)", fontSize: 13, color: "#555", lineHeight: 1.5 }}>
        Click on <strong>Admin</strong> (at the top). Then click on <strong>API Keys</strong> (side bar).
      </Typography>
      <Typography component="li" sx={{ fontFamily: "var(--theo-font-sans)", fontSize: 13, color: "#555", lineHeight: 1.5 }}>
        Click on &quot;<strong>API Documentation</strong>&quot; link
      </Typography>
      <Typography component="li" sx={{ fontFamily: "var(--theo-font-sans)", fontSize: 13, color: "#555", lineHeight: 1.5 }}>
        The <strong>Base URL</strong> will be shown at the top
        <Box component="ul" sx={{ m: 0, mt: 0.5, pl: 2.5, "& li": { mb: 0.5 } }}>
          <Typography component="li" sx={{ fontFamily: "var(--theo-font-sans)", fontSize: 13, color: "#555", lineHeight: 1.5 }}>
            Example: &quot;runtheo.huducloud.com/api/v1&quot;
          </Typography>
        </Box>
      </Typography>
    </Box>

    <Typography sx={{ fontFamily: "var(--theo-font-sans)", fontWeight: 600, fontSize: 14, color: "#1a1a1a", mb: 1 }}>
      2. Generate API Key
    </Typography>
    <Box component="ul" sx={{ m: 0, pl: 2.5, mb: 1, "& > li": { mb: 0.75 } }}>
      <Typography component="li" sx={{ fontFamily: "var(--theo-font-sans)", fontSize: 13, color: "#555", lineHeight: 1.5 }}>
        Click on <strong>Admin</strong> (at the top). Then click on <strong>API Keys</strong> (side bar).
      </Typography>
      <Typography component="li" sx={{ fontFamily: "var(--theo-font-sans)", fontSize: 13, color: "#555", lineHeight: 1.5 }}>
        Click on <strong>New API Key</strong>
        <Box component="ul" sx={{ m: 0, mt: 0.5, pl: 2.5, "& li": { mb: 0.5 } }}>
          <Typography component="li" sx={{ fontFamily: "var(--theo-font-sans)", fontSize: 13, color: "#555", lineHeight: 1.5 }}>
            <strong>Name</strong>: Give it a clear name (e.g., &quot;Theo AI&quot;)
          </Typography>
          <Typography component="li" sx={{ fontFamily: "var(--theo-font-sans)", fontSize: 13, color: "#555", lineHeight: 1.5 }}>
            <strong>Limit scope to</strong>
            <Box component="ul" sx={{ m: 0, mt: 0.5, pl: 2.5, "& li": { mb: 0.5 } }}>
              <Typography component="li" sx={{ fontFamily: "var(--theo-font-sans)", fontSize: 13, color: "#555", lineHeight: 1.5 }}>
                Select <strong>Full access</strong>
              </Typography>
            </Box>
          </Typography>
          <Typography component="li" sx={{ fontFamily: "var(--theo-font-sans)", fontSize: 13, color: "#555", lineHeight: 1.5 }}>
            Company Field: Leave empty to grant access to all companies
          </Typography>
          <Typography component="li" sx={{ fontFamily: "var(--theo-font-sans)", fontSize: 13, color: "#555", lineHeight: 1.5 }}>
            Enable <strong>View Passwords</strong> to allow password access
          </Typography>
          <Typography component="li" sx={{ fontFamily: "var(--theo-font-sans)", fontSize: 13, color: "#555", lineHeight: 1.5 }}>
            Enable <strong>Delete Data</strong> to allow deletion support
          </Typography>
          <Typography component="li" sx={{ fontFamily: "var(--theo-font-sans)", fontSize: 13, color: "#555", lineHeight: 1.5 }}>
            Enable <strong>Export Data</strong> to allow search on data
          </Typography>
          <Typography component="li" sx={{ fontFamily: "var(--theo-font-sans)", fontSize: 13, color: "#555", lineHeight: 1.5 }}>
            Click <strong>Create</strong>
          </Typography>
        </Box>
      </Typography>
    </Box>
    <Typography sx={{ fontFamily: "var(--theo-font-sans)", fontSize: 13, color: "#555", lineHeight: 1.5, fontWeight: 600 }}>
      Important:{" "}
      <Typography component="span" sx={{ fontFamily: "var(--theo-font-sans)", fontSize: 13, color: "#555", lineHeight: 1.5, fontWeight: 400 }}>
        Copy the API Key immediately. This is the ONLY time it will be visible.
      </Typography>
    </Typography>
  </>
);
